import { FC, HTMLAttributes, useEffect, useRef, useState } from "react";
import { clsx } from "clsx";
import { getScoreGrade } from "../../../common/Grade";
import classes from "./DealScore.module.less";

export interface DealScoreProps extends HTMLAttributes<HTMLDivElement> {
    score: number;
    optimizedScore?: number;
}

export const DealScore: FC<DealScoreProps> = ({
    className,
    score,
    optimizedScore,
    ...restProps
}) => {
    const labelRef = useRef<HTMLSpanElement>(null);
    const [labelWidth, setLabelWidth] = useState(0);

    const showOptimized = optimizedScore != null && optimizedScore > score;

    useEffect(() => {
        if (labelRef.current) {
            setLabelWidth(labelRef.current.offsetWidth);
        }
    }, [score]);

    return (
        <div {...restProps} className={clsx(className, classes.dealScore)}>
            <div className={classes.scoreBarWrapper}>
                <div className={classes.scoreBar}>
                    <div
                        className={classes.scoreBarFill}
                        style={{
                            width: `${score}%`,
                            backgroundSize: `${(100 / score) * 100}% 100%`,
                        }}
                    />
                </div>
                {showOptimized && (
                    <div
                        className={classes.optimizedMarker}
                        style={{ left: `${optimizedScore}%` }}
                    />
                )}
                <span
                    ref={labelRef}
                    className={classes.scoreBarLabel}
                    style={{ left: `max(8px, calc(${score}% - ${labelWidth + 10}px))` }}
                >
                    {score}% ({getScoreGrade(score).grade})
                </span>
            </div>
        </div>
    );
};

DealScore.displayName = "DealScore";
